import React from 'react'

export interface ProjectDetailKpiTileProps {
  title: string
  value: string
  sub: string
}

export function ProjectDetailKpiTile({
  title,
  value,
  sub,
}: ProjectDetailKpiTileProps) {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-2.5 shadow-sm">
      <p className="text-[10px] font-semibold uppercase tracking-wide text-slate-500">
        {title}
      </p>
      <p className="text-base font-bold text-slate-900 tabular-nums mt-0.5">
        {value}
      </p>
      <p className="text-[10px] text-slate-500 mt-0.5 line-clamp-2">{sub}</p>
    </div>
  )
}
